var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 330,
    height: 141,
    viewBox: "0 0 330 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_0_56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.55,
    d: "M17.9872 24.4808C20.2597 24.4808 22.1019 22.6365 22.1019 20.3614C22.1019 18.0864 20.2597 16.2421 17.9872 16.2421C15.7147 16.2421 13.8725 18.0864 13.8725 20.3614C13.8725 22.6365 15.7147 24.4808 17.9872 24.4808Z",
    fill: "#8F7AE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.55,
    d: "M85.7036 5.88481C87.3268 5.88481 88.6427 4.56745 88.6427 2.9424C88.6427 1.31736 87.3268 0 85.7036 0C84.0804 0 82.7645 1.31736 82.7645 2.9424C82.7645 4.56745 84.0804 5.88481 85.7036 5.88481Z",
    fill: "#5B93F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.55,
    d: "M160.944 29.3063C162.243 29.3063 163.295 28.2525 163.295 26.9524C163.295 25.6524 162.243 24.5985 160.944 24.5985C159.645 24.5985 158.593 25.6524 158.593 26.9524C158.593 28.2525 159.645 29.3063 160.944 29.3063Z",
    fill: "#E8865F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.55,
    d: "M243.709 10.828C245.656 10.828 247.235 9.24722 247.235 7.29716C247.235 5.34711 245.656 3.76628 243.709 3.76628C241.761 3.76628 240.182 5.34711 240.182 7.29716C240.182 9.24722 241.761 10.828 243.709 10.828Z",
    fill: "#3EC7B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.55,
    d: "M311.425 36.4858C313.048 36.4858 314.364 35.1685 314.364 33.5434C314.364 31.9184 313.048 30.601 311.425 30.601C309.802 30.601 308.486 31.9184 308.486 33.5434C308.486 35.1685 309.802 36.4858 311.425 36.4858Z",
    fill: "#E2648F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.55,
    d: "M40.5593 84.0351C41.8579 84.0351 42.9106 82.9812 42.9106 81.6811C42.9106 80.3811 41.8579 79.3272 40.5593 79.3272C39.2607 79.3272 38.208 80.3811 38.208 81.6811C38.208 82.9812 39.2607 84.0351 40.5593 84.0351Z",
    fill: "#F0A17C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.55,
    d: "M326.473 94.0392C328.421 94.0392 330 92.4584 330 90.5083C330 88.5583 328.421 86.9775 326.473 86.9775C324.525 86.9775 322.946 88.5583 322.946 90.5083C322.946 92.4584 324.525 94.0392 326.473 94.0392Z",
    fill: "#8F7AE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.55,
    d: "M2.93908 132.761C4.56229 132.761 5.87816 131.444 5.87816 129.819C5.87816 128.194 4.56229 126.876 2.93908 126.876C1.31587 126.876 0 128.194 0 129.819C0 131.444 1.31587 132.761 2.93908 132.761Z",
    fill: "#5B93F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.55,
    d: "M288.853 141C290.151 141 291.204 139.946 291.204 138.646C291.204 137.346 290.151 136.292 288.853 136.292C287.554 136.292 286.502 137.346 286.502 138.646C286.502 139.946 287.554 141 288.853 141Z",
    fill: "#3EC7B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.55,
    d: "M115.8 57.2003C116.774 57.2003 117.563 56.4099 117.563 55.4349C117.563 54.4599 116.774 53.6694 115.8 53.6694C114.826 53.6694 114.036 54.4599 114.036 55.4349C114.036 56.4099 114.826 57.2003 115.8 57.2003Z",
    fill: "#E2648F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.55,
    d: "M221.136 75.3255C222.435 75.3255 223.488 74.2717 223.488 72.9716C223.488 71.6716 222.435 70.6177 221.136 70.6177C219.838 70.6177 218.785 71.6716 218.785 72.9716C218.785 74.2717 219.838 75.3255 221.136 75.3255Z",
    fill: "#8F7AE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 141,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.7d69698f4b83f7bd2cc51b4629c4a13c.svg";
export { ForwardRef as ReactComponent };